"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var semantic_ui_react_1 = require("semantic-ui-react");
var numberHelpers_1 = require("../../../helpers/numberHelpers");
var lodash_1 = __importDefault(require("lodash"));
var BlTextInput = function (_a) {
    var type = _a.type, isNaturalNumber = _a.isNaturalNumber, isNonNegativeNumber = _a.isNonNegativeNumber, onChange = _a.onChange, placeHolders = _a.placeHolders, fieldName = _a.fieldName, value = _a.value, isNumberCommaFormat = _a.isNumberCommaFormat, maxLength = _a.maxLength, rest = __rest(_a, ["type", "isNaturalNumber", "isNonNegativeNumber", "onChange", "placeHolders", "fieldName", "value", "isNumberCommaFormat", "maxLength"]);
    var getType = function () {
        if (type === 'number') {
            return 'tel';
        }
        return type;
    };
    //TODO need to use composition functionality for!
    var handleInputChange = function (event, data) {
        if (data.value.length) {
            if ((type === 'number' &&
                isNaturalNumber &&
                numberHelpers_1.checkIsNaturalNumber(data.value)) ||
                (!isNaturalNumber && numberHelpers_1.onlyNumberAndADot(data.value))) {
                if (isNaN(parseInt(data.value))) {
                    data.value = numberHelpers_1.replaceFirstDotToEmpty(data.value);
                }
                onChange(numberHelpers_1.replaceZeroToEmpty(data.value));
            }
            if (isNonNegativeNumber &&
                numberHelpers_1.checkIsNaturalNumberWithZero(data.value)) {
                onChange(String(parseInt(data.value)));
            }
            if (!lodash_1.default.isUndefined(isNumberCommaFormat) && isNumberCommaFormat) {
                numberHelpers_1.onlyNumberAndADot(numberHelpers_1.revertCommaNumber(data.value)) &&
                    onChange(numberHelpers_1.replaceZeroToEmpty(numberHelpers_1.revertCommaNumber(data.value)));
            }
            else if (type !== 'number') {
                onChange(data.value);
            }
        }
        else {
            onChange('');
        }
    };
    var handleMaxLength = function () {
        if (!maxLength) {
            return type === 'number' ? 11 : 30;
        }
        return maxLength;
    };
    var resolveInput = function (params) {
        return (react_1.default.createElement(semantic_ui_react_1.Input, __assign({}, __assign(__assign(__assign({}, rest), { type: getType(), onChange: handleInputChange, maxLength: handleMaxLength(), placeholder: placeHolders }), params))));
    };
    return (react_1.default.createElement(react_1.default.Fragment, null, fieldName === 'max_duration' && !value
        ? resolveInput({
            defaultValue: fieldName === 'max_duration' && '240',
        })
        : resolveInput({
            value: isNumberCommaFormat && value
                ? numberHelpers_1.parseNumberToComma(value)
                : value,
        })));
};
exports.default = BlTextInput;
